<template>
  <div class="tw:flex tw:flex-col tw:gap-2">
    <div v-if="strength > 0" class="tw:grid tw:grid-cols-4 tw:gap-1.5">
      <span
        v-for="segment in 4"
        :key="segment"
        class="tw:h-1 tw:rounded-full"
        :class="segment <= strength ? toneClass : 'tw:bg-gray-200'" />
    </div>

    <!-- aria-live so screen readers hear the reading change while typing -->
    <div class="tw:flex tw:items-center tw:justify-between tw:gap-4" aria-live="polite">
      <span v-if="advice.label" class="tw:text-13 tw:font-medium" :class="labelClass">{{ advice.label }}</span>
      <span v-if="advice.hint" class="tw:text-13 tw:text-muted" :class="{ 'tw:ml-auto': advice.label }">
        {{ advice.hint }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { passwordAdvice, passwordStrength } from '@/components/registration/subcomponents/passwordStrength';

interface Props {
  password: string;
}

const props = defineProps<Props>();

/* --------------------------------- COMPUTED -------------------------------- */
const strength = computed(() => passwordStrength(props.password));
const advice = computed(() => passwordAdvice(props.password));

/** green only once the backend would accept it; amber, not red, while still typing */
const toneClass = computed(() => (strength.value === 4 ? 'tw:bg-success-700' : 'tw:bg-orange-600'));

const labelClass = computed(() => (strength.value === 4 ? 'tw:text-success-700' : 'tw:text-orange-600'));
</script>
